import { CheckoutEligibilityError, CheckoutEligibilityErrorCode } from '@pncl/common-models';

export const isCheckoutEligibilityError = (body: unknown): body is CheckoutEligibilityError =>
  Object.values<string>(CheckoutEligibilityErrorCode).includes(
    (body as { error_code?: string })?.error_code ?? '',
  );
